
import { useAuth } from "./use-auth";
import { useEffect, useState, useCallback } from "react";
import _ from "lodash";

export function useAdmin() {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);

  const checkAdminStatus = useCallback(() => {
    const hasAdminRole = _.some(_.get(user, 'roles', []), (role) => role.name === "admin");
    setIsAdmin(hasAdminRole);
  }, [user?.roles]);

  useEffect(() => {
    checkAdminStatus();
  }, [checkAdminStatus, user]);

  return { isAdmin };
}
